import GroupInvitationForm from './GroupInvitationForm';

export default GroupInvitationForm;